import { EXPENSE_TYPES } from './enums.js';
export function isExpenseLineItem(li) {
    return li.type === 'expense';
}
// ---------------------------------------------------------------------------
// Configurable expense types (admin-editable in Config → Expense Tool)
// ---------------------------------------------------------------------------
/**
 * Swiss VAT rates selectable per expense type ("MwSt CH"), as percentages.
 * 0 = explicitly VAT-exempt — in the CHF Reisespesen FIBU export, 0% (and an
 * unset rate) land in the "empty" column F.
 */
export const MWST_CH_RATES = [8.1, 3.8, 2.6, 0];
/**
 * Built-in fallback list — the historical hardcoded `EXPENSE_TYPES`, each with
 * no Kostenart / MwSt yet. Used when `config.expenseTypes` is absent/empty.
 */
export const DEFAULT_EXPENSE_TYPES = EXPENSE_TYPES.map((name) => ({ name, kostenart: null, mwstCh: null }));
/** Resolve the effective expense-type list (config override, else defaults). */
export function resolveExpenseTypes(config) {
    const t = config?.expenseTypes;
    return t && t.length > 0 ? t : DEFAULT_EXPENSE_TYPES;
}
/** Look up the config entry (incl. its Kostenart) for a given type name. */
export function expenseTypeConfigForName(types, name) {
    if (!name)
        return null;
    return types.find((t) => t.name === name) ?? null;
}
export function isTravelAllowanceLineItem(li) {
    return li.type === 'travel_allowance';
}
//# sourceMappingURL=lineItem.js.map